/* ============================================================
   LOOP STATION 納期計算エンジン  v3 (2026-08-26)
   ------------------------------------------------------------
   ・国内生産用  : .ShpTime000〜007      （日本の休日のみ除外）
   ・中国生産用  : .ShpTimeCN000〜007    （日本の休日 + 中国工場の停止期間を除外）
   ・春節の注意文: .ShpNoticeCN          （春節をまたぐ時だけ自動表示）

   ★毎年のメンテナンスは下の「MAINTAIN」ブロックだけ。
     日本の祝日は計算で自動生成するので更新不要。
     更新が必要なのは ①自社休業日 ②中国工場の停止期間 の2つだけ。
   ============================================================ */
(function () {
  "use strict";

  /* ===================== MAINTAIN ここだけ更新 ===================== */

  // ① 自社休業日（年末年始・夏季など。祝日は自動計算されるので書かない）
  var COMPANY_CLOSED = [
    "2026/1/1", "2026/1/2", "2026/1/3",          // 冬季休業
    "2026/8/13", "2026/8/14",                     // 夏季休業
    "2026/12/29", "2026/12/30", "2026/12/31",     // 冬季休業
    "2027/1/1", "2027/1/2", "2027/1/3",           // 冬季休業
    "2027/8/12", "2027/8/13",                     // 夏季休業（仮・要確認）
    "2027/12/29", "2027/12/30", "2027/12/31"
  ];

  // ② 中国工場の停止期間（旧正月は年ごとに日付が変わるため範囲で指定）
  //    春節当日: 2027/2/6, 2028/1/26, 2029/2/13, 2030/2/3
  //    ★中秋節も旧暦のため年ごとに日付が変わる。中国側（LIU様）から
  //      毎年の休業スケジュール連絡が来たら、その年の行をここに足す。
  //      2026年分は 2026-09-18 に連絡を受けて登録（中秋 9/25〜9/27・国慶 10/1〜10/7）。
  var CN_CLOSED = [
    { from: "2026/2/9",   to: "2026/3/1",   label: "春節" },
    { from: "2026/9/25",  to: "2026/9/27",  label: "中秋節" },
    { from: "2026/10/1",  to: "2026/10/7",  label: "国慶節" },
    { from: "2027/1/30",  to: "2027/2/19",  label: "春節" },
    { from: "2027/10/1",  to: "2027/10/7",  label: "国慶節" },
    { from: "2028/1/19",  to: "2028/2/8",   label: "春節" },
    { from: "2028/10/1",  to: "2028/10/7",  label: "国慶節" },
    { from: "2029/2/6",   to: "2029/2/26",  label: "春節" },
    { from: "2029/10/1",  to: "2029/10/7",  label: "国慶節" },
    { from: "2030/1/27",  to: "2030/2/16",  label: "春節" },
    { from: "2030/10/1",  to: "2030/10/7",  label: "国慶節" }
  ];

  // ③ 営業日パターン（クラス名の末尾 → 何営業日先か）
  var PATTERNS = {
    "000": 0, "001": 5, "002": 10, "003": 15,
    "004": 22, "005": 28, "006": 33, "007": 38
  };

  // ④ GW・海の日を営業日として扱う場合は true にする（現行の挙動に合わせるなら true）
  //    ※現行 delivery_date-2.js は GW と海の日を祝日リストから外していた
  var OPEN_ON_GW = false;

  /* =================== MAINTAIN ここまで =================== */

  var WEEK = ["日", "月", "火", "水", "木", "金", "土"];

  function ymd(d) {
    return d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate();
  }
  function parse(s) {
    var a = s.split("/");
    return new Date(+a[0], +a[1] - 1, +a[2]);
  }

  // --- 日本の国民の祝日を計算で求める（べた書き不要・永久に有効） ---
  var jpHolidayCache = {};
  function jpHolidays(year) {
    if (jpHolidayCache[year]) return jpHolidayCache[year];
    var h = {};
    function put(m, d) { h[year + "/" + m + "/" + d] = true; }
    // 第n月曜
    function nthMonday(m, n) {
      var d = new Date(year, m - 1, 1);
      var add = (8 - d.getDay()) % 7;      // 最初の月曜まで
      if (d.getDay() === 1) add = 0;
      return 1 + add + (n - 1) * 7;
    }
    put(1, 1);                              // 元日
    put(1, nthMonday(1, 2));                // 成人の日
    put(2, 11);                             // 建国記念の日
    put(2, 23);                             // 天皇誕生日
    // 春分の日（1980〜2099年で有効な近似式）
    put(3, Math.floor(20.8431 + 0.242194 * (year - 1980) - Math.floor((year - 1980) / 4)));
    if (!OPEN_ON_GW) {
      put(4, 29);                           // 昭和の日
      put(5, 3); put(5, 4); put(5, 5);      // 憲法記念日・みどりの日・こどもの日
      put(7, nthMonday(7, 3));              // 海の日
    }
    put(8, 11);                             // 山の日
    put(9, nthMonday(9, 3));                // 敬老の日
    put(9, Math.floor(23.2488 + 0.242194 * (year - 1980) - Math.floor((year - 1980) / 4))); // 秋分の日
    put(10, nthMonday(10, 2));              // スポーツの日
    put(11, 3);                             // 文化の日
    put(11, 23);                            // 勤労感謝の日

    // 国民の休日（祝日と祝日に挟まれた平日。例: 敬老の日と秋分の日に挟まれた9/22）
    Object.keys(h).slice().forEach(function (k) {
      var d = parse(k);
      var mid = new Date(d.getTime()); mid.setDate(mid.getDate() + 1);
      var nxt = new Date(d.getTime()); nxt.setDate(nxt.getDate() + 2);
      if (h[ymd(nxt)] && !h[ymd(mid)] && mid.getDay() !== 0) h[ymd(mid)] = true;
    });

    // 振替休日（日曜と重なったら次の平日）
    Object.keys(h).slice().forEach(function (k) {
      var d = parse(k);
      if (d.getDay() === 0) {
        var n = new Date(d.getTime());
        do { n.setDate(n.getDate() + 1); } while (h[ymd(n)]);
        h[ymd(n)] = true;
      }
    });
    jpHolidayCache[year] = h;
    return h;
  }

  var companySet = {};
  COMPANY_CLOSED.forEach(function (s) { companySet[ymd(parse(s))] = true; });

  function isJPClosed(d) {
    if (d.getDay() === 0 || d.getDay() === 6) return true;      // 土日
    var k = ymd(d);
    return !!jpHolidays(d.getFullYear())[k] || !!companySet[k];
  }

  var cnRanges = CN_CLOSED.map(function (r) {
    return { from: parse(r.from), to: parse(r.to), label: r.label };
  });
  function cnRangeOf(d) {
    for (var i = 0; i < cnRanges.length; i++) {
      if (d >= cnRanges[i].from && d <= cnRanges[i].to) return cnRanges[i];
    }
    return null;
  }

  // n営業日先を返す。useCN=true なら中国工場の停止期間も飛ばす
  function addBusinessDays(n, useCN) {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    var hit = null, hits = [], guard = 0;
    var left = n;
    while (left > 0 && guard++ < 4000) {
      d.setDate(d.getDate() + 1);
      if (isJPClosed(d)) continue;
      if (useCN) {
        var r = cnRangeOf(d);
        if (r) {
          hit = hit || r;
          if (hits.indexOf(r) < 0) hits.push(r);   // またいだ休業を全部ためる
          continue;
        }
      }
      left--;
    }
    return { date: d, hitRange: hit, hitRanges: hits };
  }

  function fmt(d) {
    return (d.getMonth() + 1) + "月" + d.getDate() + "日(" + WEEK[d.getDay()] + ")";
  }
  function setText(sel, text) {
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) els[i].innerText = text;
    return els.length;
  }

  function run() {
    var today = new Date();
    setText(".ShpTime000", fmt(today));
    setText(".ShpTimeCN000", fmt(today));

    var noticeRanges = [];
    function pickUp(res) {
      var rs = (res && res.hitRanges) || [];
      for (var j = 0; j < rs.length; j++) {
        if (noticeRanges.indexOf(rs[j]) < 0) noticeRanges.push(rs[j]);
      }
    }

    // (1) 従来方式: 決まったパターン ShpTime001〜007 / ShpTimeCN001〜007
    //     ※納期ページの既存22表がこれを使っているので残す
    Object.keys(PATTERNS).forEach(function (suf) {
      var n = PATTERNS[suf];
      if (n === 0) return;
      setText(".ShpTime" + suf, fmt(addBusinessDays(n, false).date));
      var cn = addBusinessDays(n, true);
      var used = setText(".ShpTimeCN" + suf, fmt(cn.date));
      if (used > 0) pickUp(cn);
    });

    // (2) 新方式: 営業日数をクラス名に直接書く ShpDays10 / ShpDaysCN22
    //     何営業日でも指定できるので、3営業日の倍数へ変更してもJSの修正は不要
    var cache = {};
    var any = document.querySelectorAll('[class*="ShpDays"]');
    for (var k = 0; k < any.length; k++) {
      var el = any[k];
      var cn2 = String(el.className || "").match(/ShpDays(CN)?(\d+)/);
      if (!cn2) continue;
      var useCN = !!cn2[1];
      var days = parseInt(cn2[2], 10);
      if (!(days >= 0)) continue;
      var key = (useCN ? "cn" : "jp") + days;
      if (!cache[key]) cache[key] = addBusinessDays(days, useCN);
      el.innerText = fmt(cache[key].date);
      if (useCN) pickUp(cache[key]);
    }

    // 春節・中秋節・国慶節をまたぐ時だけ注意文を出す（またがない時は何も表示しない）
    // ★またいだ休業が複数ある時は全部並べる（片方だけ出すとお客様が期間を誤解するため）
    noticeRanges.sort(function (a, b) { return a.from - b.from; });
    var box = document.querySelectorAll(".ShpNoticeCN");
    for (var i = 0; i < box.length; i++) {
      if (noticeRanges.length) {
        var labels = [], spans = [];
        for (var m = 0; m < noticeRanges.length; m++) {
          var f = noticeRanges[m].from, t = noticeRanges[m].to;
          if (labels.indexOf(noticeRanges[m].label) < 0) labels.push(noticeRanges[m].label);
          spans.push((f.getMonth() + 1) + "/" + f.getDate() + "〜" + (t.getMonth() + 1) + "/" + t.getDate());
        }
        var lab = labels.join("・");
        box[i].innerHTML =
          '<strong>中国' + lab + 'による休業のお知らせ【' + spans.join("、") +
          '】</strong><br>こちらの商品は中国生産です。<u>上記の出荷予定日は' +
          lab + '休業を含んだ日付</u>です。';
        box[i].style.display = "";
      } else {
        box[i].style.display = "none";
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  window.LOOP_DELIVERY = { addBusinessDays: addBusinessDays, fmt: fmt, isJPClosed: isJPClosed, cnRangeOf: cnRangeOf };
})();
